<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <Dialog
        :visible.sync="printDialog"
        header="Do you want to print this bill?"
        :style="{width: '35vw'}"
        :modal="true"
      >
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-rounded p-button-success" @click="printBill" label="Yes"
                    icon="pi pi-check"/>
          </div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-rounded p-button-danger" @click="closePrintDialog"
                    icon="pi pi-times" label="No"/>
          </div>
        </div>
      </Dialog>

      <Dialog header="Purchase Batch Details" @show="checkNepaliDateOrEnglish" :modal="true"
              :visible.sync="displayBasicBatchDetails"
              :closable=false :style="{width: '50vw'}" :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="name">Batch Name<span style="color:red">*</span></label>
            <InputText v-model.trim="batch" id="name"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="shortName">Bonus</label>
            <InputText v-model.trim="bonus" id="shortName"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="manufactureDate">Manufacture Date</label>
            <date-picker ref="man" v-model="manufactureDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" ref="man" v-else class="nepali-calendar form-control"
                       id="manufactureDate" v-model="manufactureDate"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="expiryDate">Expiry Date</label>
            <date-picker ref="exp" v-model="expiryDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" ref="exp" v-else class="nepali-calendar form-control"
                       id="expiryDate" v-model="expiryDate"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="shortName">Free Qty</label>
            <InputNumber id="free" mode="decimal" onfocus="if (this.value === '0.00'){this.value = ''}"
                         v-model="freeQty" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="ccPercentage">Cc Percentage</label>
            <InputNumber id="ccPercentage" mode="decimal" onfocus="if (this.value === '0.00'){this.value = ''}"
                         v-model="ccPercentage" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
        </div>
        <template #footer>
          <Button class="p-button-raised p-button-rounded" @click.prevent="closeBasicBatchDetails" label="Save"/>
          <Button @click.prevent="closeBasicBatchDetails" class="p-button-raised p-button-rounded p-button-danger"
                  label="Cancel"/>
        </template>
      </Dialog>

      <Dialog header="Variants Details" :modal="true"
              :visible.sync="displayVarientsDetails"
              :closable=false :style="{width: '50vw'}" :contentStyle="{'overflow': 'visible'}">
        <Button icon="pi pi-plus" @click="addNewVariant()" class="p-button-rounded p-button-info"/>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12">
            <DataTable :value="itemPropertyInventoryValuesDTOList" editMode="cell" class="editable-cells-table">
              <Column v-for="col of itemPropertyValuesDTOList" :field="col.entryTypeName"
                      :header="col.entryTypeName"
                      :key="col.entryTypeName">
                <template #body="slotProps">
                  <Dropdown v-model="slotProps.data[slotProps.column.field]" @change="addValueforProperty(slotProps.data[slotProps.column.field],col.entryTypeName)"
                   :options="col.childIItemMasterPropertyList"
                            optionLabel="propertyName" optionValue="propertyName" placeholder="Select Property">
                  </Dropdown>
                </template>
              </Column>
              <Column header="Value" field="propertyValue">
                <template #body="slotProps">
                  <!-- <InputText disabl v-model="slotProps.data.propertyValue" :minFractionDigits="2"
                               /> -->
                               <input type="text" class="form-control" v-model="slotProps.data.propertyValue" disabled/>
                </template>
              </Column>
              <Column header="Quantity" field="quantity">
                <template #body="slotProps">
                  <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                               :maxFracionDigits="4"/>
                </template>
              </Column>

            </DataTable>
          </div>
        </div>
        <template #footer>
          <Button class="p-button-raised p-button-rounded" @click.prevent="saveVariantDetails" label="Save"/>
          <Button @click.prevent="closeVarientsDetails" class="p-button-raised p-button-rounded p-button-danger"
                  label="Cancel"/>
        </template>
      </Dialog>

      <form>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-lg-6 p-xl-3">
            <label for="transactionDate">Date</label>
            <date-picker ref="tran" v-model="transactionDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" ref="tran" v-else class="nepali-calendar form-control"
                       id="transactionDate" v-model="transactionDate"/>
          </div>
          <div class="p-field p-col-12 p-lg-6 p-xl-3">
            <label for="transactionDate">Purchase Date</label>
            <date-picker v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="purchaseSalesDate"
                       v-model="purchaseSalesDate"/>
          </div>
          <div class="p-field p-col-12 p-lg-4 p-xl-2">
            <label for="billNo">Bill No</label>
            <InputText id="billNo" v-model="billNo" disabled/>
          </div>
          <div class="p-field p-col-12 p-lg-4 p-xl-2">
            <label for="refno">Ref. No.</label>
            <InputText id="refno" v-model="refNo"/>
          </div>
          <div class="p-field p-col-12 p-lg-4 p-xl-2">
            <label for="purType">Purchase Type</label>
            <select class="selectBox" v-model="taxType">
              <option selected disabled value="">Select One</option>
              <option v-for="(tax,ind) in taxTypeList" :key="ind">{{ tax.name }}</option>
            </select>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-lg-4 p-xl-3">
            <label for="loadFrom">Load From</label>
            <div class="radiobox">
              <div class="radiobox-itm">
                <label class="radio-inline"><input type="radio" v-model="loadType" name="order" value="order"
                  @change="loadFrom(loadType)"/>Order</label>
                </div>
                <div class="radiobox-itm">
                  <label class="radio-inline"><input type="radio" v-model="loadType" name="challan" value="challan"
                                                     @change="loadFrom(loadType)"/>Challan</label>
                </div>
            </div>
          </div>
          <div class="p-field p-col-12 p-lg-4" v-if="loadFromOrder && !this.editing">
            <label for="OrderList" v-if="loadFromOrder && !this.editing"> Order List</label>
            <Dropdown
              v-model="orderId"
              :options="orderIdList"
              optionLabel="orderNo"
              :filter="true"
              @change="loadPurchaseDataWithOrderId(orderId.orderNo)"
              placeholder="Select Item"
            />
          </div>
          <div class="p-field p-col-12 p-lg-4" v-if="loadFromChallan && !this.editing">
            <label for="ChallanList" v-if="loadFromChallan && !this.editing"> Challan List</label>
            <Dropdown
              v-model="challanId"
              :options="challanIdList"
              optionLabel="challanNo"
              :filter="true"
              @change="loadPurchaseDataWithChallanId(challanId.challanNo)"
              placeholder="Select Item"
            />
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-10 p-lg-3">
            <label>Vendor</label>
            <Dropdown
              v-model="accountMaster"
              :options="supplierAndCustomerList"
              optionLabel="name"
              :filter="true"
              placeholder="Select Account"
              :showClear="true"
            />
          </div>
          <div class="p-field p-col-2 p-lg-4 p-xl-1 align-self-end">
            <supplierDialog v-tooltip.top="'Add Supplier'"/>
          </div>
          <div v-if="ifCash" class="p-field p-col-10 p-lg-3">
            <label>Supplier</label>
            <Dropdown
              v-model="cashTransactionMaster"
              :options="customerAccountList"
              optionLabel="name"
              :filter="true"
              placeholder="Select supplier"
              :showClear="true"
            />
          </div>
          <div class="p-field p-col-2 p-lg-4 p-xl-1 align-self-end" v-if="ifCash">
            <supplierDialog v-tooltip.top="'Add Supplier'" @set_supplier_master="set_supplier_master"/>
          </div>

          <div class="p-field p-col-10 p-lg-3" v-if="accountMaster.id > 0">
            <div class="p-fluid p-formgrid p-grid p-mt-2" v-if="!ifNotCash">
          <div class="p-field p-col-12 p-md-4" v-if="accountMaster.id > 0">
            <label for="panNo">Tax No:</label>
            <b class="p-ml-0" style="margin-right:10px" id="panNo">{{ accountMaster.panNo }}</b>
          </div>
          <div class="p-field p-col-12 p-md-4" v-if="accountMaster.id > 0">
            <label for="panNo">Cur. Bal:</label>
            <b class="p-ml-4" style="color:red;" v-if="accountMaster.closingBalance>0">
              {{ (accountMaster.closingBalance).toFixed(2) + 'Cr' }}
            </b>
            <b class="p-ml-4" style="color:green;" v-else>
              {{ (accountMaster.closingBalance * (-1)).toFixed(2) + 'Dr' }}
            </b>
          </div>
          </div>

          </div>


          <div class="p-field p-col-10 p-lg-2">
            <label for="warehouse">Store</label>
            <Dropdown
              v-if="!setWarehouseData"
              v-model="warehouse"
              :options="warehouseLists"
              optionLabel="name"
              :filter="true"
              placeholder="Select store"
              :showClear="true"
            />
            <Dropdown
              v-else
              v-model="warehouse"
              :options="warehouseLists"
              optionLabel="name"
              id="warehouse"
              :filter="true"
              placeholder="Select warehouse"
              :disabled="true"
            />
          </div>
          <div class="p-field p-col-2 align-self-end">
            <warehouseDialog v-tooltip.top="'Add Warehouse'" @set_data_warehouse="set_data_warehouse"/>
          </div>
        </div>

        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-10 p-lg-3">
            <label for="itm">Item<span style="color:red">*</span></label>
            <AutoComplete v-model="items" filterMatchMode='contains' id="itm"
                          :suggestions="filteredItems" @complete="searchItem($event)"
                          field="name" ref="itm">
              <template #item="slotProps">
                <div style="font-size: 12px !important;">{{ slotProps.item.name }} - {{ slotProps.item.itemCode }}</div>
              </template>
            </AutoComplete>
          </div>
          <div class="p-field p-col-2 p-lg-4 p-xl-1 align-self-end">
            <itemDialog v-tooltip.top="'Add Item'" @set_data_item="set_data_item"/>
          </div>
          <div class="p-field p-col-12 p-lg-3 p-xl-1">
            <label for="qty">Quantity</label>
            <InputNumber id="qty" v-model="quantity" mode="decimal"
                         onfocus="if (this.value === '0.00'){this.value = ''}" :minFractionDigits="2"
                         :maxFracionDigits="4"/>
          </div>
          <div v-if="!items.isMultiUnit" class="p-field p-col-12 p-lg-3 p-xl-1">
            <label for="qty">Unit</label>
            <InputText type="text" class="form-control" v-model="items.unitName" disabled/>
          </div>
          <div v-if="items.isMultiUnit" class="p-field p-col-12 p-lg-3 p-xl-1">
            <label for="unit">Unit</label>
            <Dropdown
              v-model="alternateUnit"
              :options="items.itemMultiUnitDetailsDTOList"
              optionLabel="unitTo"
              :filter="true"
              placeholder="Select One"
              id="unit"
            />
          </div>
          <div v-if="items.isMultiUnit" class="p-field p-col-12 p-lg-3 p-xl-1">
            <label for="unit"></label>
            <Button class="p-button-rounded p-button-secondary" @click.prevent="openConversionDialog(unitConversion)"
                    label="Detail"/>
          </div>
          <UniConversionDetail ref="conversionDialog"/>
          <div class="p-field p-col-12 p-lg-3 p-xl-1">
            <label for="rate">Rate</label>
            <!-- <input type="text" class="form-control" id="rate" @keypress="isNumber(event)"  v-model="rate"/> -->
            <InputNumber id="rate" v-model="rate" mode="decimal" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div class="p-field p-col-12 p-lg-3 p-xl-2">
            <label for="total">Total</label>
            <InputNumber v-if="$store.state.organisationid != 17" disabled id="minmaxfraction"
                         v-model.lazy="total" :minFractionDigits="2" :maxFracionDigits="4"/>
            <InputNumber v-else id="minmaxfraction" @keyup="findRate" v-model="total" :minFractionDigits="2"
                         :maxFracionDigits="4"/>
          </div>
          <div style="display:none"> {{ totalAmount }}</div>
          <div style="display:none">{{ setRateFromItem }}</div>
              <div class="p-field p-col-1 p-lg-4 p-xl-1 align-self-end">
                <Button class="p-button-raised" @click.prevent="addItemToDTOList"
                        :label="!editDTO?'Add':'Update'"/>
              </div>
              <div class="p-field p-col-1 p-lg-4 p-xl-1 align-self-end" v-if="editDTO">
                <Button class="p-button-raised p-button-danger"
                        @click="itemDTOreset"
                        label="Cancel"/>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-8">
            <div class="p-fluid p-formgrid p-grid p-align-center h-100" v-if="items.id >0">
              <div class="p-field p-col-12 p-md-4 mb-0">
                <label for="avl">Current. Stock:</label>
                <span>{{ items.closingStock }}</span>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="p-field p-col-12 p-md-12 genTable">
        <div class="p-datatable-responsive p-datatable-gridlines">
          <div class="scrollable">
            <table class="table table-bordered">
              <thead>
              <tr>
                <th scope="col">SN</th>
                <th scope="col">Item Name</th>
                <th scope="col">Hs Code</th>
                <th scope="col">Quantity</th>
                <th scope="col">Unit</th>
                <th scope="col">Rate</th>
                <th scope="col">Amount</th>
                <th scope="col">Action</th>
                <th v-if="this.$store.getters.modules.includes('5.33')" scope="col">Size-Color</th>
              </tr>
              </thead>
              <tbody v-for="(item,index) in inventoryInOutDetailList " :key="index">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.itemMaster.itemNameWithCode }}</td>
                  <td>{{ item.itemMaster.hsCode }}</td>
                  <td style="text-align:right">{{ item.quantity }}</td>
                  <td style="text-align:right">{{ item.itemMaster.unitName }}</td>
                  <td style="text-align:right">{{ item.rate }}</td>
                  <td style="text-align:right">{{ (item.rate * item.quantity).toFixed(4) }}</td>
                  <td style="text-align:center">
                    <Button class="p-button-raised p-button-rounded p-button-success"
                            @click="editItemFromDTO(item,index)" icon="pi pi-pencil"/>
                    <Button class="p-button-raised p-button-rounded p-button-danger"
                            v-if="editDTO" @click="removeItemFromDTO(item, index)"
                            disabled icon="pi pi-trash"/>
                    <Button class="p-button-raised p-button-rounded p-button-danger"
                            v-else-if="!editDTO" @click="removeItemFromDTO(item, index)"
                            icon="pi pi-trash"/>
                  </td>
                  <td v-if="checkSizeAndColor" style="text-align:center">
                  <Button class="p-button-raised p-button-rounded p-button-success"
                  @click.prevent="openBasicForSizeAndColor(item)"
                  icon="pi pi-eye"/>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3">Total:</td>
                  <td>{{ totalQty }}</td>
                  <td colspan="2">&nbsp;</td>
                  <td>{{ subTotal.toFixed(2) }}</td>
                  <td>&nbsp;</td>
                  <td v-if="this.$store.getters.modules.includes('5.33')">&nbsp;</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid p-mt-2">
        <div class="p-field p-col-12 p-lg-4 p-xl-4">
          <label>Narration</label>
          <textarea type="text" rows="6" class="form-control" v-model="narration"/>
        </div>
        <div class="p-field p-col-12 p-lg-3 p-xl-2 mt-25">
          <Button icon="pi pi-refresh" label="Reset" class="p-button-warning"
                  @click="reset"/>
        </div>
        <div class="p-field p-col-12 p-lg-3 p-xl-2 mt-25">
          <form>
            <Button class="p-button p-button-success addNewBtn btn-btm-0 width-auto" label="Extra Expenses" @click.prevent="openBasic" icon="pi pi-plus"/>
            <Dialog header="Extra Expenses" :visible.sync="displayBasic" :modal="true" :closable=false
                    :contentStyle="{'overflow': 'auto'}">
              <form>
                <div class="p-fluid p-formgrid p-grid p-mt-2">
                  <div class="p-field p-col-12 p-md-9 p-lg-6 p-xl-3">
                    <label for="extraExpense">Extra Expenses Name</label>
                    <Dropdown
                      v-model="extraExpenses"
                      :options="extraExpensesList"
                      optionLabel="expensesName"
                      :filter="true"
                      placeholder="Select Expenses"
                      id="extraExpense"
                      :showClear="true"
                    />
                  </div>
                  <div class="p-field p-col-12 p-md-3 p-lg-2 p-xl-2">
                    <extraExpensesDialog class="p-mt-5" v-tooltip.top="'Add Extra Expenses'"/>
                  </div>
                  <div class="p-field p-col-12 p-lg-4 p-xl-2">
                    <label for="extraExpensesAmt">Amount</label>
                    <InputText v-model="extraExpenseAmt" id="extraExpensesAmt"/>
                  </div>
                  <div class="p-field p-col-12 p-xl-2">
                    <div class="radiobox">
                      <div class="radiobox-itm">
                        <label for="applyVat">Apply Vat</label>
                        <InputSwitch v-model="applyVat"/>
                      </div>
                      <div class="radiobox-itm">
                        <label for="applyVat">Apply On Bill</label>
                        <InputSwitch v-model="applyExpensesOnBill"/>
                      </div>
                    </div>
                  </div>
                  <div class="p-field p-offset-7 p-col-5 p-lg-offset-0 p-lg-3">
                    <div class="p-fluid p-grid justify-content-end">
                      <div class="p-field p-col-6 p-mt-5">
                        <Button class="p-button-info btn-btm-0 width-auto p-button"
                                @click.prevent="addExtraExpensesToList" :label="!editExtraExpenses?'Add':'Update'"/>
                      </div>
                      <div class="p-field p-col-6 p-mt-5" v-if="editExtraExpenses">
                        <Button class="p-button p-button-danger width-auto" @click.prevent="cancelExtraExpenses" label="Cancel"/>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="p-datatable-responsive p-datatable-gridlines finalCalc">
                <table class="table table-bordered">
                  <thead>
                  <tr>
                    <th>S.N</th>
                    <th>Expenses Name</th>
                    <th>Apply Vat</th>
                    <th>Amount</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody v-for="(expense,index) in inventoryExtraExpensesList" :key="index">
                  <tr>
                    <td>{{ index + 1 }}</td>
                    <td>{{ expense.extraExpense.expensesName }}</td>
                    <td>{{ expense.applyVat ? 'Yes' : 'No' }}</td>
                    <td>{{ expense.extraExpenseAmt }}</td>
                    <td>
                      <Button class="p-button-raised p-button-rounded p-button-success"
                              @click.prevent="editExtraExpensesDto(expense,index)"
                              icon="pi pi-pencil"/>
                      <Button class="p-button-raised p-button-rounded p-button-danger"
                              v-if="editExtraExpenses"
                              @click.prevent="removeExtraExpense(expense, index)" disabled icon="pi pi-trash"/>
                      <Button class="p-button-raised p-button-rounded p-button-danger" v-else
                              @click.prevent="removeExtraExpense(expense, index)"
                              icon="pi pi-trash"/>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <template #footer>
                <Button icon="pi pi-save" class="p-button-raised p-button-success" @click.prevent="closeBasic" label="Save"/>
                <Button @click.prevent="closeBasic" class="p-button-danger"
                        label="Cancel"/>
              </template>
            </Dialog>
          </form>
        </div>
        <div class="p-field p-col-12 p-lg-9 p-xl-4">
          <div class="p-datatable-responsive p-datatable-gridlines finalCalc">
            <table class="table table-bordered" >
              <thead>
              <tr >
                <th>Subtotal</th>
                <th></th>
                <td>{{ subTotal.toFixed(4) }}</td>
              </tr>
              <tr >
                <th>Discount</th>
                <th>
                  <Button v-if="chooseDiscountAmt" @click="chooseDisountAmt" label="Rs"/>
                  <Button v-if="chooseDiscountPer" @click="chooseDisPercent" label="%"/>
                </th>
                <td>
                  <InputText onfocus="if (this.value === '0'){this.value = ''}" v-if="chooseDiscountPer"
                             v-model="discountPer"
                             placeholder="discountPer"/>
                  <InputText onfocus="if (this.value === '0'){this.value = ''}" v-if="chooseDiscountAmt"
                             v-model="discountAmt"
                             placeholder="discountamt"/>
                </td>
              </tr>
              <tr>
                <th>Discounted Amt:</th>
                <th></th>
                <td>{{ discountAmt }}</td>
              </tr>
              <tr>
                <th>Excise Duty</th>
                <th>
                  <!-- <InputText onfocus="if (this.value === '0'){this.value = ''}" v-model="exciseDuty"/> -->
                  <InputNumber id="excise" v-model="exciseDuty" mode="decimal"
                         onfocus="if (this.value === '0.00'){this.value = ''}" :minFractionDigits="2"
                         :maxFracionDigits="4"/> %
                </th>
                <!-- <th></th> -->
                <td>{{ exciseDuty }}</td>
                <!-- <input type="text" class="form-control" v-model="exciseDuty"/> -->
              </tr>
              <tr>
                <th>Taxable</th>
                <th></th>
                <td>{{ taxable.toFixed(4) }}</td>
              </tr>
              <tr>
                <th>Non-taxable</th>
                <th></th>
                <td>{{ nonTaxable.toFixed(4) }}</td>
              </tr>
  
  
              <tr>
                <th>Tax</th>
                <th>13%</th>
                <td>{{ tax.toFixed(4) }}</td>
              </tr>
              <tr>
                <th>Total</th>
                <th></th>
                <td>{{ totalBillAmount.toFixed(4) }}</td>
              </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-6 p-md-4 p-xl-2 p-xl-offset-6">
          <Button icon="pi pi-save" class="p-button-raised p-button-success"
                  @click="addPurchaseInvoice"
                  :label="purchaseInvoice === undefined ? 'Save': 'Update'"/>
        </div>
        <!-- <div class="p-field p-col-6 p-md-2" v-if="purchaseInvoice ==undefined">
          <Button class="p-button-raised p-button-warning" @click="reset" label="Reset"
                  icon="pi pi-refresh"/>
        </div> -->
        <div class="p-field p-col-6 p-md-2" v-if="purchaseInvoice!=undefined">
          <Button class="p-button-raised p-button-danger" @click="goBack()" label="Cancel"/>
        </div>
        <div class="p-field p-col-6 p-md-2">
          <Button class="p-button-raised p-button-info" label="Print" icon="pi pi-print"/>
        </div>
        <div class="p-field p-col-6 p-md-4 p-xl-2">
          <Button icon="pi pi-download" v-if="saved" label="Generate PDF"
                  class="p-button-raised p-button-secondary"
                  @click="printBill"/>
          <Button icon="pi pi-download" v-else disabled label="Generate PDF"
                  class="p-button-raised p-button-secondary"
                  @click="printBill"/>
        </div>
      </div>
    </div>

    <Dialog header="Size Details" :visible.sync="displayBasicForSizeAndColor"
                    :style="{width: '50vw', height:'20vw'}" :modal="true" :closable=false
                    :contentStyle="{'overflow': 'visible'}">
              <form>
                <div class="p-fluid p-formgrid p-grid p-mt-2">
                  <div class="p-field p-col-12 p-md-2">
                    <label for="extraExpense">Size</label>
                    <Dropdown
                      v-model="sizeName"
                      :options="sizeLists"
                      optionLabel="label"
                      optionValue="value"
                      :filter="true"
                      placeholder="Select Size"
                      id="extraExpense"
                      :showClear="true"
                    />
                  </div>
                  <div class="p-field p-col-12 p-md-2">
                    <label for="extraExpense">Color</label>
                    <Dropdown
                      v-model="colorName"
                      :options="colorLists"
                      optionLabel="label"
                      optionValue="value"
                      :filter="true"
                      placeholder="Select Size"
                      id="extraExpense"
                      :showClear="true"
                    />
                  </div>

                    <div class="p-field p-col-12 p-md-2">
                    <label for="extraExpense">Closing Stock</label>
                  <InputNumber disabled id="inQuantity" mode="decimal" onfocus="if (this.value === '0.00'){this.value = ''}"
                         v-model="quantity" :minFractionDigits="2" :maxFracionDigits="4"/>
                  </div>
                  <div class="p-field p-col-12 p-md-2">
                    <label for="extraExpense">In Qty</label>
                  <InputNumber id="quantity" mode="decimal" onfocus="if (this.value === '0.00'){this.value = ''}"
                         v-model="inQuantity" :minFractionDigits="2" :maxFracionDigits="4"/>
                  </div>
    
                  <div class="p-field p-col-12 p-md-1 p-mt-5">
                    <Button class="p-button-raised"
                             @click.prevent="addInventoryStockSize" :label="!editDto?'Add':'Update'"/>
                  </div>
                   <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button class="p-button-raised p-button-danger" v-if="editDto" @click="itemDTOresetForSizeAndColor"
                    label="Cancel"/>
          </div>
                </div>
              </form>
              <table class="table table-bordered" style="margin-top: 2em;border: 1px solid #c8c8c8;">
                <thead>
                <tr>
                  <th>S.N</th>
                  <th>Size</th>
                  <th>Color</th>
                  <th>Quantity</th>
                    <th>In Quantity</th>
                  <!-- <th>Amount</th> -->
                  <th>Action</th>
                </tr>
                </thead>
                <tbody v-for="(expense,index) in inventoryStockSizeList" :key="index">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ expense.size }}</td>
                   <td>{{ expense.color }}</td>
                  <td>{{ expense.quantity }}</td>
                   <td>{{ expense.inQuantity }}</td>
                  <!-- <td>{{ expense.extraExpenseAmt }}</td> -->
                  <td>
                    <Button class="p-button-raised p-button-success"
                            @click.prevent="editExtraExpensesDto(expense,index)"
                            icon="pi pi-pencil"/>
                    <Button class="p-button-raised p-button-danger"
                            @click.prevent="removeExtraExpense(expense, index)"
                            icon="pi pi-trash"/>
                  </td>
                </tr>
                </tbody>
              </table>
              <template #footer>
                <Button class="p-button-raised p-button-success" @click.prevent="closeBasicSizeAndColor" label="Save"/>
                <Button @click.prevent="closeBasicSizeAndColorCancel" class="p-button-raised p-button-danger"
                        label="Cancel"/>
              </template>
            </Dialog>

  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputSwitch from 'primevue/inputswitch'
import Dialog from 'primevue/dialog'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import supplierDialog from '../accountDialog/SupplierAccountDialog'
import warehouseDialog from '../warehouseDialog/warehouseDialog'
import itemDialog from '../itemDialog/itemMasterDialog'
import extraExpensesDialog from '../billSundryDialog/billSundryPurchaseDialog'
import RadioButton from 'primevue/radiobutton'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import UniConversionDetail from '../commonDialogs/UnitConversionDetail'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

export default {
  name: 'purchaseInvoice',
  props: ['purchaseInvoice'],
  data() {
    return {
      name: '',
      warehouse: '',
      taxTypeList: [
        {name: 'Exclusive', code: 'Exclusive'},
        {name: 'Inclusive', code: 'Inclusive'},
        {name: 'Exempt', code: 'Exempt'}
      ],
      items: '',
      accountMaster: '',
      cashTransactionMaster: '',
      quantity: 0,
      rate: 0,
      checkSizeAndColor: false,
      purchaseSalesDate: null,
      foundRateOnItem: false,
      manufactureDate: null,
      expiryDate: null,
      transactionDate: null,
      inventoryInOutDetailList: [],
      itemPropertyValuesDTOList: [],
      itemPropertyInventoryValuesDTOList: [],
      inventoryInOutDetailDeleteList: [],
      inventoryExtraExpensesList: [],
      inventoryExtraExpensesDeletedList: [],
      inventorySizeDetailsDTOList: [],
      inventoryStockSizeList: [],
      itemMasterId: '',
      sizeName: '',
      colorName: '',
      inQuantity: 0,
      taxType: '',
      unitConversion: '',
      taxable: 0,
      tax: 0,
      val: '',
      nonTaxable: 0,
      vatPercentage: '',
      purchaseMessage: '',
      editing: false,
      billNo: null,
      index: null,
      inventoryHeaderId: null,
      id: null,
      editDTO: false,
      refNo: null,
      loading: true,
      itemSelected: '',
      pro: '',
      totalQty: 0,
      total: 0,
      extraExpensesList: null,
      accountMasterListForExtraExpenses: [],
      customerAccountList: [],
      applyExpensesOnBill: false,
      discountPer: 0,
      exciseDuty: 0.0,
      discountAmt: 0,
      exciseChargeAmount: 0.0,
      displayBasic: false,
      displayBasicForSizeAndColor: false,
      displayBasicBatchDetails: false,
      tempClosingStock: 0.0,
      sumInQty: 0.0,
      displayVarientsDetails: false,
      extraExpenses: '',
      applyVat: false,
      editExtraExpenses: false,
      filteredItems: null,
      printDialog: false,
      headerId: null,
      saved: false,
      disableDeleteBtn: false,
      extraExpenseAmt: 0,
      englishDateEnabled: true,
      narration: '',
      loadFromOrder: false,
      loadFromChallan: false,
      loadType: '',
      orderIdList: [],
      orderId: null,
      challanId: null,
      challanIdList: [],
      setWarehouseData: false,
      chooseDiscountPer: false,
      chooseDiscountAmt: true,
      propertyValue: '',
      bonus: '',
      batch: '',
      freeQty: 0.0,
      ccRate: 0,
      ccPercentage: 0.0,
      taxableQty: 0.0,
      nonTaxableQty: 0.0,
      alternateUnit: '',
      sizeLists: [{label: 'S', value: 'S'}, {label: 'M', value: 'M'}, {label: 'L', value: 'L'}, {label: 'Xl', value: 'Xl'}, {label: 'XXL', value: 'XXL'}, {label: 'XXXL', value: 'XXXL'}],
      colorLists: [{label: 'Red', value: 'Red'}, {label: 'Black', value: 'Black'}, {label: 'White', value: 'White'}, {label: 'Blue', value: 'Blue'}, {label: 'Green', value: 'Green'}, {label: 'Yellow', value: 'Yellow'}]
    }
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    supplierAndCustomerList() {
      return this.$store.state.accountMaster.supplierCustomerCashList
    },
    unitConversionLists() {
      return this.$store.state.itemgroup.unitConversionLists
    },
    itemMasterListByItemType() {
      return this.$store.state.itemMaster.itemMasterListByItemType
    },
    ifCash() {
      if (this.accountMaster.name === 'Cash' || this.accountMaster.name === 'cash') {
        return true
      }
    },
    ifNotCash() {
      if (this.accountMaster.name === 'Cash' || this.accountMaster === '') {
        return true
      }
    },
    totalAmount() {
      if (this.quantity > 0 && this.rate > 0) {
        let totalAmt = 0
        totalAmt = parseFloat(this.quantity) * parseFloat(this.rate)
        if (isNaN(totalAmt)) {
          totalAmt = 0.00
        }
        this.total = totalAmt.toFixed(2)
        return totalAmt
      }
    },
    findCcRate() {
      this.ccRate = 0
      if (this.ccPercentage > 0 && this.rate > 0) {
        let ccR = 0.0
        ccR = parseFloat(this.rate) * parseFloat(this.ccPercentage) / 100
        if (isNaN(ccR)) {
          ccR = 0.00
        }
        this.ccRate = ccR.toFixed(2)
        return ccR
      }
    },
    setRateFromItem() {
      if (!this.editDTO) {
        let rate = 0
        this.rate = this.items.purchaseRate
        this.itemPropertyValuesDTOList = this.items.itemPropertyValuesDTOList
        return rate
      }
    },
    subTotal() {
      let subTotal = 0
      let discountPerItem = 0
      let totalDiscountPerItem = 0
      // this.discountAmt = 0
      this.exciseChargeAmount = 0
      this.taxable = 0.0
      this.tax = 0.0
      this.nonTaxable = 0
      this.taxableQty = 0.0
      this.nonTaxableQty = 0.0
      this.totalQty = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].ccPercentage) / 100) * this.inventoryInOutDetailList[i].freeQty
        this.itemSelected = this.inventoryInOutDetailList[i].itemMaster
        this.totalQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
        if (this.inventoryInOutDetailList[i].ccPercentage > 0) {
          this.totalQty += parseFloat(this.inventoryInOutDetailList[i].freeQty)
        }
        if (this.chooseDiscountPer === true) {
          if (this.discountPer > 100) {
            this.$toast.add({severity: 'error', summary: '', detail: 'Discount must be less than 100 %', life: 10000})
            return
          }
          // this.discountAmt = (parseFloat(subTotal) * this.discountPer / 100).toFixed(4)
          if (this.discountAmt === '') {
            this.discountAmt = 0
          }
          this.discountAmt = (parseFloat(subTotal) * this.discountPer / 100)
          discountPerItem = parseFloat(this.discountAmt) / parseFloat(this.totalQty)
        }
        if (this.chooseDiscountAmt === true) {
          if (this.discountAmt === '') {
            this.discountAmt = 0.0
          }
          discountPerItem = parseFloat(this.discountAmt) / parseFloat(this.totalQty)
        }

        switch (this.taxType) {
          case 'Exclusive':
            if (this.itemSelected.vatable) {
              this.tax = 0
              // totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
              // this.taxable = subTotal - parseFloat(totalDiscountPerItem)
              this.taxable = subTotal
              // this.taxable = subTotal - (discountPerItem * this.totalQty)
              this.taxableQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
              if (this.inventoryInOutDetailList[i].ccPercentage > 0) {
                this.taxableQty += parseFloat(this.inventoryInOutDetailList[i].freeQty)
              }
              this.taxable -= parseFloat(discountPerItem) * this.taxableQty
              // if (this.exciseDutyCal > 0) {
              // this.exciseChargeAmount = this.exciseDuty
              // // debugger
              // }
              // this.taxable += this.exciseDutyCal
              // this.taxableCal()
              // // debugger
              if (this.exciseDutyCal > 0) {
                this.taxable += this.exciseDutyCal
              }
              this.tax += parseFloat(this.taxable * 0.13)
              this.addExtraExpenses()
            } else {
              // totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
              this.nonTaxable += ((parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity)) - parseFloat(totalDiscountPerItem))
              this.addExtraExpenses()
            }
            break
          case 'Inclusive':
            if (this.itemSelected.vatable) {
              // totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
              // subTotal = parseFloat(subTotal) - parseFloat(totalDiscountPerItem)
              subTotal = parseFloat(subTotal)
              let amtWithoutVat = ((parseFloat(subTotal * 100)) / (parseFloat(100 + 13))).toFixed(4)
              this.taxable += (parseFloat(amtWithoutVat))
              this.taxableQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
              if (this.inventoryInOutDetailList[i].ccPercentage > 0) {
                this.taxableQty += parseFloat(this.inventoryInOutDetailList[i].freeQty)
              }
              if (this.exciseDutyCal > 0) {
                this.exciseChargeAmount = this.exciseDutyCal
              }
              this.tax += (parseFloat(subTotal) - parseFloat(amtWithoutVat))
              this.addExtraExpenses()
            } else {
              // totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
              this.nonTaxable += ((parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity)) - totalDiscountPerItem)
              this.addExtraExpenses()
            }
            break
          case 'Exempt':
            // totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
            this.nonTaxable += ((parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity)) - totalDiscountPerItem)
            this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].ccPercentage) / 100) * this.inventoryInOutDetailList[i].freeQty
            this.nonTaxableQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
            if (this.inventoryInOutDetailList[i].ccPercentage > 0) {
              this.nonTaxableQty += parseFloat(this.inventoryInOutDetailList[i].freeQty)
            }
            break
        }
      }
      if (this.discountAmt > subTotal) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Discount Amount must be less than total Amount!',
          life: 10000
        })
        return
      }
      this.nonTaxable -= parseFloat(discountPerItem) * this.nonTaxableQty
      // this.taxable += this.exciseDutyCal()
      return subTotal
    },
    closeBasicSizeAndColor() {
      this.displayBasicForSizeAndColor = false
      // this.editExtraExpenses = false
      this.sumInQty = 0.0
      for (let i = 0; i < this.inventoryStockSizeList.length; i++) {
        this.sumInQty += this.inventoryStockSizeList[i].inQuantity
      }
    },
    closeBasicSizeAndColorCancel() {
      this.displayBasicForSizeAndColor = false
      // this.editExtraExpenses = false
      this.sumInQty = 0.0
      this.itemDTOresetForSizeAndColor()
    },
    exciseDutyCal() {
      let exc = 0.0
      if (this.exciseDuty === '') {
        this.exciseDuty = 0
      }
      exc = parseFloat(this.exciseDuty)
      return exc
    },
    totalBillAmount() {
      let totalBillAmount = 0.0
      totalBillAmount = parseFloat(this.taxable) + parseFloat(this.tax) + parseFloat(this.nonTaxable)
      return totalBillAmount
    }
  },
  mounted() {
    const promises = [
      this.findUnitConversionList(),
      this.warehouseList(),
      this.supplierCustomerCashList(),
      this.customerSupplierList(),
      this.maxPurchaseBillNo(),
      this.extraPurchaseExpenses(),
      this.itemMasterListByItemTypes(),
      this.accountMasterForExtraExpenses()
    ]
    if (this.purchaseInvoice !== undefined) {
      promises.push(this.editPurchase())
    }
    Promise.all(promises)
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Failed to load data',
          life: 10000
        })
      })
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.purchaseInvoice === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.setWarehouse()
  },
  methods: {
    async findUnitConversionList() {
      await this.$store.dispatch('loadUnitConversionList')
    },
    addExtraExpenses() {
      if (this.inventoryExtraExpensesList.length > 0 & this.applyExpensesOnBill) {
        for (let i = 0; i < this.inventoryExtraExpensesList.length; i++) {
          if (this.inventoryExtraExpensesList[i].applyVat) {
            this.taxable += parseFloat(this.inventoryExtraExpensesList[i].extraExpenseAmt)
          } else {
            this.nonTaxable += parseFloat(this.inventoryExtraExpensesList[i].extraExpenseAmt)
          }
        }
      }
    },
    async customerSupplierList() {
      let response = await this.$store.dispatch('loadsupplierAndCustomerList')
      if (response.data.status === 'SUCCESS') {
        this.customerAccountList = response.data.data
      }
    },
    async accountMasterForExtraExpenses() {
      let response = await this.$store.dispatch('loadOfficeAccountListForDropdown')
      this.accountMasterForExtraExpenses = response.data.data
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async supplierCustomerCashList() {
      await this.$store.dispatch('loadsupplierCustomerAndCashList')
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadItemMasterListByItemTypePurchase')
    },
    async extraPurchaseExpenses() {
      let resp = await this.$store.dispatch('extraPurchaseExpenses')
      this.extraExpensesList = resp.data.data
    },
    async maxPurchaseBillNo() {
      let response = await this.$store.dispatch('maxPurchaseBillNo')
      if (this.purchaseInvoice === undefined) {
        this.billNo = response.data.data
        this.purchaseMessage = response.data.message
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.billNo = this.purchaseInvoice.edit.billNo
        this.purchaseMessage = this.purchaseInvoice.edit.remarks
      }
    },
    addItemToDTOList() {
      let item = {
        itemId: this.items.id,
        itemMaster: this.items,
        quantity: this.quantity,
        rate: this.rate,
        unitName: this.items.unitName,
        id: this.id,
        bonus: this.bonus,
        batch: this.batch,
        freeQty: this.freeQty,
        cc: this.ccRate,
        manufactureDate: this.manufactureDate,
        expiryDate: this.expiryDate,
        ccPercentage: this.ccPercentage,
        itemPropertyValuesDTOList: this.itemPropertyInventoryValuesDTOList,
        inventorySizeDetailsDTOList: []
      }
      if (this.taxType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select purchase type!', life: 10000})
        return
      }
      if (this.accountMaster === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select vendor!', life: 10000})
        return
      }
      if (this.warehouse === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
      if (this.items.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Invalid item!', life: 10000})
        return
      }
      if (this.items === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
        return
      } else if (this.quantity <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0!', life: 10000})
        return
      } else if (this.rate <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Rate must be greater than 0!', life: 10000})
        return
      } else {
        if (!this.editDTO) {
          this.inventoryInOutDetailList.push({...item})
        } else {
          this.inventoryInOutDetailList.splice(this.index, 1, {...item})
        }
      }
      this.itemDTOreset()
      this.focusInput()
    },
    async editItemFromDTO(item, index) {
      this.itemDTOreset()
      this.disableDeleteBtn = true
      this.items = item.itemMaster
      this.foundRateOnItem = false
      this.rate = item.rate
      this.quantity = item.quantity
      this.bonus = item.bonus
      this.batch = item.batch
      this.ccRate = item.cc
      this.ccPercentage = item.ccPercentage
      this.freeQty = item.freeQty
      this.manufactureDate = item.manufactureDate
      this.expiryDate = item.expiryDate
      this.total = (parseFloat(item.rate) * parseFloat(item.quantity)).toFixed(2)
      this.editDTO = true
      this.index = index
      if (item.id !== undefined) {
        this.id = item.id
      }
      // // debugger
    },
    addExtraExpensesToList() {
      if (this.extraExpenses === null || this.extraExpenses === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select Extra Expenses!', life: 10000})
        return
      }
      if (this.extraExpenseAmt < 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please Enter VAT amount!', life: 10000})
        return
      }
      let extraExpense = {
        extraExpense: this.extraExpenses,
        id: this.extraExpenses.id,
        extraExpenseAmt: this.extraExpenseAmt,
        applyVat: this.applyVat
      }
      if (!this.editExtraExpenses) {
        this.inventoryExtraExpensesList.push({...extraExpense})
      } else {
        this.inventoryExtraExpensesList.splice(this.index, 1, {...extraExpense})
      }
      this.editExtraExpenses = false
      this.resetExtraExpenses()
    },
    editExtraExpensesDto(data, index) {
      this.resetExtraExpenses()
      this.extraExpenses = data.extraExpense
      this.editExtraExpenses = true
      this.index = index
      this.applyVat = data.applyVat
      this.extraExpenseAmt = data.extraExpenseAmt
      if (data.extraExpense.id != null) {
        this.id = data.extraExpense.id
      }
    },
    removeExtraExpense(data, index) {
      if (this.editing) {
        this.inventoryExtraExpensesDeletedList.push({...data})
      }
      this.inventoryExtraExpensesList.splice(index, 1)
    },
    cancelExtraExpenses() {
      this.editExtraExpenses = false
      this.resetExtraExpenses()
    },
    async addPurchaseInvoice() {
      if (this.purchaseSalesDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter Purchase date!', life: 10000})
        return
      }
      let response = ''
      if (this.cashTransactionMaster === undefined) {
        this.cashTransactionMaster == null
      }
      if (this.discountPer > 100) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Discount percentage cannot be greater than 100!',
          life: 10000
        })
        return
      }
      let purchaseInvoice = {
        billNo: this.billNo,
        warehouseId: this.warehouse.id,
        accountMasterId: this.accountMaster.id,
        purchaseSalesDate: this.purchaseSalesDate,
        purchaseSalesDateNepali: this.purchaseSalesDate,
        transactionDate: this.transactionDate,
        transactionDateNepali: this.transactionDate,
        referenceNumber: this.refNo,
        fiscalYearId: this.$store.state.fyId,
        taxType: this.taxType,
        remarks: this.narration,
        discountPercentage: this.discountPer,
        discount: this.discountAmt,
        exciseChargeAmount: this.exciseDuty,
        subTotalAmount: this.subTotal,
        totalBillAmount: this.totalBillAmount,
        cashTransactionId: this.cashTransactionMaster.id,
        applyExpensesOnBill: this.applyExpensesOnBill,
        inventoryHeaderId: this.inventoryHeaderId,
        inventoryInOutDetailList: this.inventoryInOutDetailList,
        inventoryInOutDetailDeleteList: this.inventoryInOutDetailDeleteList,
        inventoryExtraExpensesList: this.inventoryExtraExpensesList,
        sumOfQuantity: this.totalQty
      }
      // // debugger
      if (purchaseInvoice.inventoryInOutDetailList.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item !', life: 10000})
        return
      }
      if (this.purchaseInvoice === undefined) {
        this.loading = true
        response = await this.$store.dispatch('addPurchaseInvoice', purchaseInvoice)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updatePurchaseInvoice', purchaseInvoice)
        this.loading = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        // this.$emit('update-message', response.data.message)
        await this.maxPurchaseBillNo()
        await this.supplierCustomerCashList()
        await this.customerSupplierList()
        await this.itemMasterListByItemTypes()
        this.reset()
        this.saved = true
        this.headerId = response.data.data.id
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    checkSizeAndColor() {
    },
    set_data_warehouse(data) {
      let warehouse = {
        id: data.id,
        name: data.name
      }
      this.warehouse = warehouse
      this.warehouseList()
    },
    set_data_item(data) {
      this.itemMasterListByItemTypes()
      this.items = data
      data.itemNameWithCode = data.name
      this.items.itemNameWithCode = this.items.name
    },
    set_supplier_master(data) {
      this.supplierCustomerList()
      this.accountMasterId = data
    },
    async editPurchase() {
      this.editing = true
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.purchaseSalesDate = this.purchaseInvoice.edit.purchaseSalesDateNepali
        this.transactionDate = this.purchaseInvoice.edit.transactionDateNepali
        this.manufactureDate = this.purchaseInvoice.edit.manufactureDateNepali
        this.expiryDate = this.purchaseInvoice.edit.expiryDateNepali
      } else {
        this.purchaseSalesDate = this.purchaseInvoice.edit.purchaseDate
        this.transactionDate = this.purchaseInvoice.edit.transactionDate
        this.manufactureDate = this.purchaseInvoice.edit.manufactureDate
        this.expiryDate = this.purchaseInvoice.edit.expiryDate
      }
      this.refNo = this.purchaseInvoice.edit.referenceNumber
      this.taxType = this.purchaseInvoice.edit.vatTypeEnum
      this.warehouse = this.purchaseInvoice.edit.warehouse
      this.narration = this.purchaseInvoice.edit.remarks
      this.discountPer = this.purchaseInvoice.edit.discountPercentage
      this.discountAmt = this.purchaseInvoice.edit.discount
      this.exciseDuty = this.purchaseInvoice.edit.exciseChargeAmount
      this.accountMaster = this.purchaseInvoice.edit.accountMaster
      this.cashTransactionMaster = this.purchaseInvoice.edit.cashTransactionMaster
      this.inventoryHeaderId = this.purchaseInvoice.edit.id
      this.inventoryInOutDetailList = this.purchaseInvoice.edit.inventoryInOutDetailList
      this.inventoryExtraExpensesList = this.purchaseInvoice.edit.inventoryExtraExpensesListForReport
      if (parseFloat(this.rate) > 0) {
        this.foundRateOnItem = true
      }
    },
    removeItemFromDTO(data, id) {
      if (this.editing && data.id !== null) {
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.inventoryInOutDetailList.splice(id, 1)
    },
    goBack() {
      if (this.inventoryInOutDetailDeleteList.length > 0) {
        this.purchaseInvoice.edit.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
      }
      this.$router.back()
    },
    itemDTOreset() {
      this.items = ''
      this.rate = 0
      this.quantity = 0
      this.total = 0
      this.editDTO = false
      this.itemSelected = ''
      this.id = null
      this.disableDeleteBtn = false
      this.expiryDate = null
      this.manufactureDate = null
      this.freeQty = 0.0
      this.batch = ''
      this.bonus = ''
      this.ccRate = 0
      this.ccPercentage = 0.0
      this.inventoryStockSizeList = []
    },
    findRate() {
      if (isNaN(this.rate)) {
        this.rate = 0
      }
      if (isNaN(this.total)) {
        this.total = 0
      }
      if (isNaN(this.quantity)) {
        this.quantity = 0
      }
      if (parseFloat(this.rate) > 0) {
        this.foundRateOnItem = true
      }
      this.rate = (parseFloat(this.rate))
      this.total = (parseFloat(this.total))
      this.quantity = (parseFloat(this.quantity))
      // if (this.foundRateOnItem) {
      // if (this.rate === 0) {
      let rates = 0
      if (this.total > 0 && this.quantity > 0) {
        rates = parseFloat(this.total) / parseFloat(this.quantity)
        this.rate = rates.toFixed(2)
      }
      if (isNaN(rates)) {
        rates = 0
      }
      if (isNaN(this.total)) {
        this.total = 0
      }
      return rates
    },
    reset() {
      this.itemDTOreset()
      this.discountPer = 0
      this.warehouse = ''
      this.accountMaster = ''
      this.referenceNumber = ''
      this.exciseDuty = 0.0
      this.discountPer = 0
      this.discountAmt = 0
      this.inventoryInOutDetailList = []
      this.refNo = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
        this.transactionDate = new Date().toISOString().slice(0, 10)
        this.manufactureDate = new Date().toISOString().slice(0, 10)
        this.expiryDate = new Date().toISOString().slice(0, 10)
      }
      this.taxType = ''
      this.inventoryExtraExpensesList = []
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    checkNepaliDateOrEnglish() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate && this.purchaseInvoice === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    openBasic() {
      this.displayBasic = true
    },
    openBasicBatchDetails() {
      this.displayBasicBatchDetails = true
    },
    openVariantsDetails() {
      this.displayVarientsDetails = true
    },
    closeBasic() {
      this.displayBasic = false
      this.editExtraExpenses = false
    },
    closeVarientsDetails() {
      this.displayVarientsDetails = false
    },
    closeBasicBatchDetails() {
      this.displayBasicBatchDetails = false
      this.editExtraExpenses = false
    },
    resetExtraExpenses() {
      this.extraExpenses = ''
      this.applyVat = false
      this.extraExpenseAmt = ''
    },
    openBasicForSizeAndColor(data) {
      this.inventoryStockSizeList = data.inventorySizeDetailsDTOList
      this.itemMasterId = data.item
      this.displayBasicForSizeAndColor = true
      this.sumInQty = 0
      this.tempClosingStock = data.closingStock
    },
    addInventoryStockSize() {
      let item = {
        size: this.sizeName,
        color: this.colorName,
        quantity: this.quantity,
        inQuantity: this.inQuantity,
        itemMasterId: this.itemMasterId
      }
      if (!this.editDto) {
        this.inventoryStockSizeList.push({...item})
      } else {
        this.inventoryStockSizeList.splice(this.index, 1, {...item})
      }
      this.sizeName = ''
      this.colorName = ''
      this.quantity = 0
      this.inQuantity = 0
      this.editDto = false
    },
    setNepaliDate() {
      if (this.purchaseInvoice === undefined) {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
        this.transactionDate = this.$store.getters.nepaliNewDate
        this.manufactureDate = this.$store.getters.nepaliNewDate
        this.expiryDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
      $('#transactionDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.transactionDate = $('#transactionDate').val()
        }
      })
      if (this.displayBasicBatchDetails) {
        $('#manufactureDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.manufactureDate = $('#manufactureDate').val()
          }
        })
        $('#expiryDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.expiryDate = $('#expiryDate').val()
          }
        })
      }
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().includes(event.query.toLowerCase()) || item.itemCode.includes(event.query)
          })
        }
      }, 250)
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      this.transactionDate = new Date().toISOString().slice(0, 10)
      this.manufactureDate = new Date().toISOString().slice(0, 10)
      this.expiryDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    // openPrintDialog(data) {
    //   this.printDialog = true
    //   this.headerId = data
    // },
    printBill() {
      let purchaseInvoice = {
        id: this.headerId,
        type: 'printPurchaseBill',
        report: 'PurchaseInvoice'
      }
      this.printDialog = false
      this.$store.dispatch('exportToPdf', purchaseInvoice)
      this.focusAfterSave()
      this.saved = false
    },
    closePrintDialog() {
      this.printDialog = false
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouse = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouse = this.warehouseLists[0]
      }
    },
    async loadFrom(data) {
      if (data === 'order') {
        let orderIds = await this.$store.dispatch('loadOrderIdList')
        this.orderIdList = orderIds.data.data
        this.loadFromOrder = true
        this.loadFromChallan = false
      }
      if (data === 'challan') {
        let challanIds = await this.$store.dispatch('challanIdList')
        this.challanIdList = challanIds.data.data
        this.loadFromChallan = true
        this.loadFromOrder = false
      }
    },
    async loadPurchaseDataWithOrderId(order) {
      let response = await this.$store.dispatch('loadDataWithOrderId', order)
      if (response.data.data.length > 0) {
        response.data.data.forEach(data => {
          if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
            this.purchaseSalesDate = data.purchaseSalesDateNepali
          } else {
            this.purchaseSalesDate = data.purchaseDate
          }
          // this.narration = data.remarks
          this.refNo = data.referenceNumber
          this.warehouse = data.warehouse
          this.accountMaster = data.accountMaster
          this.inventoryInOutDetailList = data.inventoryInOutDetailList
        })
      }
    },
    async loadPurchaseDataWithChallanId(challan) {
      let response = await this.$store.dispatch('loadDataWithPurchaseChallanNo', challan)
      if (response.data.data.length > 0) {
        response.data.data.forEach(data => {
          if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
            this.purchaseSalesDate = data.purchaseDate
          } else {
            this.purchaseSalesDate = data.purchaseDate
          }
          // this.narration = data.remarks
          this.refNo = data.referenceNumber
          this.warehouse = data.warehouse
          this.accountMaster = data.warehouse
          this.inventoryInOutDetailList = data.inventoryInOutDetailList
        })
      }
    },
    chooseDisPercent() {
      this.chooseDiscountPer = false
      this.chooseDiscountAmt = true
      this.discountPer = 0
    },
    itemDTOresetForSizeAndColor() {
      this.sizeName = ''
      this.sumInQty = ''
      this.colorName = ''
      this.quantity = 0
      this.editDto = false
      this.id = null
    },
    chooseDisountAmt() {
      this.chooseDiscountAmt = false
      this.chooseDiscountPer = true
      this.discountAmt = 0
    },
    openConversionDialog(unitConver) {
      let unitConversion = {
        uniConversion: unitConver,
        isPurchaseSales: 'purchase'
      }
      this.$refs.conversionDialog.openDialog(unitConversion)
    },
    addValueforProperty(data, head) {
      this.propertyValue = data
      this.pro += head + ':' + data + ','
    },
    addNewVariant() {
      let item = {
        quantity: 0.0,
        propertyValue: ''
      }
      this.itemPropertyInventoryValuesDTOList.push({...item})
    },
    saveVariantDetails() {
      this.itemPropertyInventoryValuesDTOList.forEach((itmPro) => {
        itmPro.propertyValue = this.pro
        if (itmPro.quantity !== this.quantity) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Quantity provided must be equal!', life: 10000})
          return
        }
      })
      this.displayVarientsDetails = false
    }
  },
  components: {
    Dropdown,
    DatePicker,
    InputText,
    InputSwitch,
    Dialog,
    AutoComplete,
    InputNumber,
    InputMask,
    supplierDialog,
    warehouseDialog,
    itemDialog,
    extraExpensesDialog,
    RadioButton,
    Button,
    Textarea,
    UniConversionDetail,
    DataTable,
    Column
  }
}
</script>

<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// purchaseinvoice.vue?7c48c845